// extracted by mini-css-extract-plugin
export default {"page":"l1-z","cartModal":"m1-z","checkout":"n1-z","placeholder":"o1-z","account":"p1-z"};